var map = {
	"./AntDesign.ttf": [
		25221,
		5221
	],
	"./Entypo.ttf": [
		18783,
		8783
	],
	"./EvilIcons.ttf": [
		19544,
		9544
	],
	"./Feather.ttf": [
		18785,
		8785
	],
	"./FontAwesome.ttf": [
		27836,
		5455
	],
	"./FontAwesome5_Brands.ttf": [
		58946,
		8946
	],
	"./FontAwesome5_Regular.ttf": [
		63456,
		3456
	],
	"./FontAwesome5_Solid.ttf": [
		95765,
		5765
	],
	"./FontAwesome6_Brands.ttf": [
		54875,
		4875
	],
	"./FontAwesome6_Regular.ttf": [
		23507,
		3507
	],
	"./FontAwesome6_Solid.ttf": [
		17946,
		7946
	],
	"./Fontisto.ttf": [
		63060,
		3060
	],
	"./Foundation.ttf": [
		99255,
		9255
	],
	"./Ionicons.ttf": [
		99168,
		9168
	],
	"./MaterialCommunityIcons.ttf": [
		19060,
		9060
	],
	"./MaterialIcons.ttf": [
		76987,
		9368
	],
	"./Octicons.ttf": [
		99828,
		9828
	],
	"./SimpleLineIcons.ttf": [
		93514,
		3514
	],
	"./Zocial.ttf": [
		40458,
		458
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 51727;
module.exports = webpackAsyncContext;